/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type ProcurementType,
    ProcurementTypeFromJSON,
    ProcurementTypeToJSON,
} from '../models/ProcurementType';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';
import {
    type Vehicle,
    VehicleFromJSON,
    VehicleToJSON,
} from '../models/Vehicle';
import {
    type VehicleCreate,
    VehicleCreateFromJSON,
    VehicleCreateToJSON,
} from '../models/VehicleCreate';
import {
    type VehicleFleetStatistics,
    VehicleFleetStatisticsFromJSON,
    VehicleFleetStatisticsToJSON,
} from '../models/VehicleFleetStatistics';
import {
    type VehicleLastSynchronizedAtUpdate,
    VehicleLastSynchronizedAtUpdateFromJSON,
    VehicleLastSynchronizedAtUpdateToJSON,
} from '../models/VehicleLastSynchronizedAtUpdate';
import {
    type VehicleListStats,
    VehicleListStatsFromJSON,
    VehicleListStatsToJSON,
} from '../models/VehicleListStats';
import {
    type VehicleSortKey,
    VehicleSortKeyFromJSON,
    VehicleSortKeyToJSON,
} from '../models/VehicleSortKey';
import {
    type VehicleUpdate,
    VehicleUpdateFromJSON,
    VehicleUpdateToJSON,
} from '../models/VehicleUpdate';

export interface VehiclesCreateVehicleRequest {
    vehicleCreate: VehicleCreate;
}

export interface VehiclesDeleteVehicleRequest {
    vehicleId: string;
}

export interface VehiclesExportVehicleListRequest {
    timezone: string;
    exportType: VehiclesExportVehicleListExportType;
    listType: VehiclesExportVehicleListListType;
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    search?: string | null;
    includeInactive?: boolean | null;
    departmentIds?: Array<string> | null;
    vehicleGroupIds?: Array<string> | null;
    procurementTypes?: Array<ProcurementType> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: VehicleSortKey;
}

export interface VehiclesListVehiclesRequest {
    pageSize: number;
    search?: string | null;
    dateStart?: Date;
    dateEnd?: Date;
    includeInactive?: boolean | null;
    departmentIds?: Array<string> | null;
    vehicleGroupIds?: Array<string> | null;
    procurementTypes?: Array<ProcurementType> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: VehicleSortKey;
}

export interface VehiclesListVehiclesMetadataRequest {
    pageSize: number;
    search?: string | null;
    includeInactive?: boolean | null;
    departmentIds?: Array<string> | null;
    vehicleGroupIds?: Array<string> | null;
    procurementTypes?: Array<ProcurementType> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: VehicleSortKey;
}

export interface VehiclesReadVehicleRequest {
    vehicleId: string;
}

export interface VehiclesReadVehicleCostInformationRequest {
    costsPeriodStart: Date;
    costsPeriodEnd: Date;
}

export interface VehiclesReadVehicleListStatsRequest {
    pageSize: number;
    dateStart?: Date;
    dateEnd?: Date;
    search?: string | null;
    includeInactive?: boolean | null;
    departmentIds?: Array<string> | null;
    vehicleGroupIds?: Array<string> | null;
    procurementTypes?: Array<ProcurementType> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: VehicleSortKey;
}

export interface VehiclesUpdateVehicleRequest {
    vehicleId: string;
    vehicleUpdate: VehicleUpdate;
}

export interface VehiclesUpdateVehicleLastSynchronizedAtRequest {
    vehicleLastSynchronizedAtUpdate: VehicleLastSynchronizedAtUpdate;
}

export interface VehiclesValidateCreateVehicleRequest {
    vehicleCreate: VehicleCreate;
}

export interface VehiclesValidateUpdateVehicleRequest {
    vehicleId: string;
    vehicleUpdate: VehicleUpdate;
}

/**
 * VehiclesApi - interface
 * 
 * @export
 * @interface VehiclesApiInterface
 */
export interface VehiclesApiInterface {
    /**
     * Creates request options for vehiclesCreateVehicle without sending the request
     * @param {VehicleCreate} vehicleCreate 
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesCreateVehicleRequestOpts(requestParameters: VehiclesCreateVehicleRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new vehicle.
     * @summary Create a vehicle
     * @param {VehicleCreate} vehicleCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesCreateVehicleRaw(requestParameters: VehiclesCreateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Vehicle>>;

    /**
     * Create a new vehicle.
     * Create a vehicle
     */
    vehiclesCreateVehicle(requestParameters: VehiclesCreateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Vehicle>;

    /**
     * Creates request options for vehiclesDeleteVehicle without sending the request
     * @param {string} vehicleId 
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesDeleteVehicleRequestOpts(requestParameters: VehiclesDeleteVehicleRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the vehicle with the given ID.
     * @summary Delete a vehicle
     * @param {string} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesDeleteVehicleRaw(requestParameters: VehiclesDeleteVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the vehicle with the given ID.
     * Delete a vehicle
     */
    vehiclesDeleteVehicle(requestParameters: VehiclesDeleteVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for vehiclesExportVehicleList without sending the request
     * @param {string} timezone 
     * @param {'csv' | 'xlsx'} exportType 
     * @param {'trucks' | 'productivity'} listType 
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {boolean} [includeInactive] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {Array<ProcurementType>} [procurementTypes] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesExportVehicleListRequestOpts(requestParameters: VehiclesExportVehicleListRequest): Promise<runtime.RequestOpts>;

    /**
     * Exports all vehicles with consideration of optional filters.
     * @summary Export vehicle list as csv or xlsx
     * @param {string} timezone 
     * @param {'csv' | 'xlsx'} exportType 
     * @param {'trucks' | 'productivity'} listType 
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {boolean} [includeInactive] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {Array<ProcurementType>} [procurementTypes] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesExportVehicleListRaw(requestParameters: VehiclesExportVehicleListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Exports all vehicles with consideration of optional filters.
     * Export vehicle list as csv or xlsx
     */
    vehiclesExportVehicleList(requestParameters: VehiclesExportVehicleListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Creates request options for vehiclesListVehicles without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {boolean} [includeInactive] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {Array<ProcurementType>} [procurementTypes] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesListVehiclesRequestOpts(requestParameters: VehiclesListVehiclesRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the vehicle present.  Optionally filter by `user_id` to return all `Vehicle`s which are assigned to the `User`. If `search` is specified, return values similar to the `serialNumber` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * @summary List vehicles
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {boolean} [includeInactive] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {Array<ProcurementType>} [procurementTypes] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesListVehiclesRaw(requestParameters: VehiclesListVehiclesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Vehicle>>>;

    /**
     * Lists all the vehicle present.  Optionally filter by `user_id` to return all `Vehicle`s which are assigned to the `User`. If `search` is specified, return values similar to the `serialNumber` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List vehicles
     */
    vehiclesListVehicles(requestParameters: VehiclesListVehiclesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Vehicle>>;

    /**
     * Creates request options for vehiclesListVehiclesMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {boolean} [includeInactive] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {Array<ProcurementType>} [procurementTypes] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesListVehiclesMetadataRequestOpts(requestParameters: VehiclesListVehiclesMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Vehicle listing metadata
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {boolean} [includeInactive] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {Array<ProcurementType>} [procurementTypes] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesListVehiclesMetadataRaw(requestParameters: VehiclesListVehiclesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Vehicle listing metadata
     */
    vehiclesListVehiclesMetadata(requestParameters: VehiclesListVehiclesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for vehiclesReadVehicle without sending the request
     * @param {string} vehicleId 
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesReadVehicleRequestOpts(requestParameters: VehiclesReadVehicleRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the vehicle specified by the given ID.
     * @summary Get a single vehicle
     * @param {string} vehicleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesReadVehicleRaw(requestParameters: VehiclesReadVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Vehicle>>;

    /**
     * Returns the vehicle specified by the given ID.
     * Get a single vehicle
     */
    vehiclesReadVehicle(requestParameters: VehiclesReadVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Vehicle>;

    /**
     * Creates request options for vehiclesReadVehicleByVehicleDeviceSerialNumber without sending the request
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesReadVehicleByVehicleDeviceSerialNumberRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * Returns only the vehicle of vehicle device token
     * @summary Get a single vehicle by vehicle device.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesReadVehicleByVehicleDeviceSerialNumberRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Vehicle>>;

    /**
     * Returns only the vehicle of vehicle device token
     * Get a single vehicle by vehicle device.
     */
    vehiclesReadVehicleByVehicleDeviceSerialNumber(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Vehicle>;

    /**
     * Creates request options for vehiclesReadVehicleCostInformation without sending the request
     * @param {Date} costsPeriodStart 
     * @param {Date} costsPeriodEnd 
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesReadVehicleCostInformationRequestOpts(requestParameters: VehiclesReadVehicleCostInformationRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns only the vehicle of vehicle device token
     * @summary Get a single vehicle by vehicle device.
     * @param {Date} costsPeriodStart 
     * @param {Date} costsPeriodEnd 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesReadVehicleCostInformationRaw(requestParameters: VehiclesReadVehicleCostInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleFleetStatistics>>;

    /**
     * Returns only the vehicle of vehicle device token
     * Get a single vehicle by vehicle device.
     */
    vehiclesReadVehicleCostInformation(requestParameters: VehiclesReadVehicleCostInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleFleetStatistics>;

    /**
     * Creates request options for vehiclesReadVehicleListStats without sending the request
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {boolean} [includeInactive] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {Array<ProcurementType>} [procurementTypes] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesReadVehicleListStatsRequestOpts(requestParameters: VehiclesReadVehicleListStatsRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch summed up stats of filtered vehicles.
     * @summary Read summed up stats of all filtered vehicles.
     * @param {number} pageSize 
     * @param {Date} [dateStart] 
     * @param {Date} [dateEnd] 
     * @param {string} [search] 
     * @param {boolean} [includeInactive] 
     * @param {Array<string>} [departmentIds] 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {Array<ProcurementType>} [procurementTypes] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {VehicleSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesReadVehicleListStatsRaw(requestParameters: VehiclesReadVehicleListStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleListStats>>;

    /**
     * Fetch summed up stats of filtered vehicles.
     * Read summed up stats of all filtered vehicles.
     */
    vehiclesReadVehicleListStats(requestParameters: VehiclesReadVehicleListStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleListStats>;

    /**
     * Creates request options for vehiclesUpdateVehicle without sending the request
     * @param {string} vehicleId 
     * @param {VehicleUpdate} vehicleUpdate 
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesUpdateVehicleRequestOpts(requestParameters: VehiclesUpdateVehicleRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the vehicle specified by the given ID.
     * @summary Update vehicle
     * @param {string} vehicleId 
     * @param {VehicleUpdate} vehicleUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesUpdateVehicleRaw(requestParameters: VehiclesUpdateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Vehicle>>;

    /**
     * Update the vehicle specified by the given ID.
     * Update vehicle
     */
    vehiclesUpdateVehicle(requestParameters: VehiclesUpdateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Vehicle>;

    /**
     * Creates request options for vehiclesUpdateVehicleLastSynchronizedAt without sending the request
     * @param {VehicleLastSynchronizedAtUpdate} vehicleLastSynchronizedAtUpdate 
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesUpdateVehicleLastSynchronizedAtRequestOpts(requestParameters: VehiclesUpdateVehicleLastSynchronizedAtRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the last synchronization date of the vehicle specified by the given ID.
     * @summary Update vehicle last synchronization date
     * @param {VehicleLastSynchronizedAtUpdate} vehicleLastSynchronizedAtUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesUpdateVehicleLastSynchronizedAtRaw(requestParameters: VehiclesUpdateVehicleLastSynchronizedAtRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Vehicle>>;

    /**
     * Update the last synchronization date of the vehicle specified by the given ID.
     * Update vehicle last synchronization date
     */
    vehiclesUpdateVehicleLastSynchronizedAt(requestParameters: VehiclesUpdateVehicleLastSynchronizedAtRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Vehicle>;

    /**
     * Creates request options for vehiclesValidateCreateVehicle without sending the request
     * @param {VehicleCreate} vehicleCreate 
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesValidateCreateVehicleRequestOpts(requestParameters: VehiclesValidateCreateVehicleRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new vehicle without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a vehicle
     * @param {VehicleCreate} vehicleCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesValidateCreateVehicleRaw(requestParameters: VehiclesValidateCreateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new vehicle without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a vehicle
     */
    vehiclesValidateCreateVehicle(requestParameters: VehiclesValidateCreateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for vehiclesValidateUpdateVehicle without sending the request
     * @param {string} vehicleId 
     * @param {VehicleUpdate} vehicleUpdate 
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesValidateUpdateVehicleRequestOpts(requestParameters: VehiclesValidateUpdateVehicleRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given vehicle, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate vehicle update
     * @param {string} vehicleId 
     * @param {VehicleUpdate} vehicleUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApiInterface
     */
    vehiclesValidateUpdateVehicleRaw(requestParameters: VehiclesValidateUpdateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given vehicle, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate vehicle update
     */
    vehiclesValidateUpdateVehicle(requestParameters: VehiclesValidateUpdateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class VehiclesApi extends runtime.BaseAPI implements VehiclesApiInterface {

    /**
     * Creates request options for vehiclesCreateVehicle without sending the request
     */
    async vehiclesCreateVehicleRequestOpts(requestParameters: VehiclesCreateVehicleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleCreate'] == null) {
            throw new runtime.RequiredError(
                'vehicleCreate',
                'Required parameter "vehicleCreate" was null or undefined when calling vehiclesCreateVehicle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicles/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleCreateToJSON(requestParameters['vehicleCreate']),
        };
    }

    /**
     * Create a new vehicle.
     * Create a vehicle
     */
    async vehiclesCreateVehicleRaw(requestParameters: VehiclesCreateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Vehicle>> {
        const requestOptions = await this.vehiclesCreateVehicleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleFromJSON(jsonValue));
    }

    /**
     * Create a new vehicle.
     * Create a vehicle
     */
    async vehiclesCreateVehicle(requestParameters: VehiclesCreateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Vehicle> {
        const response = await this.vehiclesCreateVehicleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehiclesDeleteVehicle without sending the request
     */
    async vehiclesDeleteVehicleRequestOpts(requestParameters: VehiclesDeleteVehicleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleId'] == null) {
            throw new runtime.RequiredError(
                'vehicleId',
                'Required parameter "vehicleId" was null or undefined when calling vehiclesDeleteVehicle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicles/{vehicle_id}`;
        urlPath = urlPath.replace('{vehicle_id}', encodeURIComponent(String(requestParameters['vehicleId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the vehicle with the given ID.
     * Delete a vehicle
     */
    async vehiclesDeleteVehicleRaw(requestParameters: VehiclesDeleteVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehiclesDeleteVehicleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the vehicle with the given ID.
     * Delete a vehicle
     */
    async vehiclesDeleteVehicle(requestParameters: VehiclesDeleteVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehiclesDeleteVehicleRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for vehiclesExportVehicleList without sending the request
     */
    async vehiclesExportVehicleListRequestOpts(requestParameters: VehiclesExportVehicleListRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['timezone'] == null) {
            throw new runtime.RequiredError(
                'timezone',
                'Required parameter "timezone" was null or undefined when calling vehiclesExportVehicleList().'
            );
        }

        if (requestParameters['exportType'] == null) {
            throw new runtime.RequiredError(
                'exportType',
                'Required parameter "exportType" was null or undefined when calling vehiclesExportVehicleList().'
            );
        }

        if (requestParameters['listType'] == null) {
            throw new runtime.RequiredError(
                'listType',
                'Required parameter "listType" was null or undefined when calling vehiclesExportVehicleList().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehiclesExportVehicleList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['timezone'] != null) {
            queryParameters['timezone'] = requestParameters['timezone'];
        }

        if (requestParameters['exportType'] != null) {
            queryParameters['export_type'] = requestParameters['exportType'];
        }

        if (requestParameters['listType'] != null) {
            queryParameters['list_type'] = requestParameters['listType'];
        }

        if (requestParameters['includeInactive'] != null) {
            queryParameters['include_inactive'] = requestParameters['includeInactive'];
        }

        if (requestParameters['departmentIds'] != null) {
            queryParameters['department_ids'] = requestParameters['departmentIds'];
        }

        if (requestParameters['vehicleGroupIds'] != null) {
            queryParameters['vehicle_group_ids'] = requestParameters['vehicleGroupIds'];
        }

        if (requestParameters['procurementTypes'] != null) {
            queryParameters['procurement_types'] = requestParameters['procurementTypes'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicles/export`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Exports all vehicles with consideration of optional filters.
     * Export vehicle list as csv or xlsx
     */
    async vehiclesExportVehicleListRaw(requestParameters: VehiclesExportVehicleListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.vehiclesExportVehicleListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Exports all vehicles with consideration of optional filters.
     * Export vehicle list as csv or xlsx
     */
    async vehiclesExportVehicleList(requestParameters: VehiclesExportVehicleListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.vehiclesExportVehicleListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehiclesListVehicles without sending the request
     */
    async vehiclesListVehiclesRequestOpts(requestParameters: VehiclesListVehiclesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehiclesListVehicles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['includeInactive'] != null) {
            queryParameters['include_inactive'] = requestParameters['includeInactive'];
        }

        if (requestParameters['departmentIds'] != null) {
            queryParameters['department_ids'] = requestParameters['departmentIds'];
        }

        if (requestParameters['vehicleGroupIds'] != null) {
            queryParameters['vehicle_group_ids'] = requestParameters['vehicleGroupIds'];
        }

        if (requestParameters['procurementTypes'] != null) {
            queryParameters['procurement_types'] = requestParameters['procurementTypes'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicles/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the vehicle present.  Optionally filter by `user_id` to return all `Vehicle`s which are assigned to the `User`. If `search` is specified, return values similar to the `serialNumber` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List vehicles
     */
    async vehiclesListVehiclesRaw(requestParameters: VehiclesListVehiclesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Vehicle>>> {
        const requestOptions = await this.vehiclesListVehiclesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(VehicleFromJSON));
    }

    /**
     * Lists all the vehicle present.  Optionally filter by `user_id` to return all `Vehicle`s which are assigned to the `User`. If `search` is specified, return values similar to the `serialNumber` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List vehicles
     */
    async vehiclesListVehicles(requestParameters: VehiclesListVehiclesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Vehicle>> {
        const response = await this.vehiclesListVehiclesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehiclesListVehiclesMetadata without sending the request
     */
    async vehiclesListVehiclesMetadataRequestOpts(requestParameters: VehiclesListVehiclesMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehiclesListVehiclesMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['includeInactive'] != null) {
            queryParameters['include_inactive'] = requestParameters['includeInactive'];
        }

        if (requestParameters['departmentIds'] != null) {
            queryParameters['department_ids'] = requestParameters['departmentIds'];
        }

        if (requestParameters['vehicleGroupIds'] != null) {
            queryParameters['vehicle_group_ids'] = requestParameters['vehicleGroupIds'];
        }

        if (requestParameters['procurementTypes'] != null) {
            queryParameters['procurement_types'] = requestParameters['procurementTypes'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicles/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Vehicle listing metadata
     */
    async vehiclesListVehiclesMetadataRaw(requestParameters: VehiclesListVehiclesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.vehiclesListVehiclesMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Vehicle listing metadata
     */
    async vehiclesListVehiclesMetadata(requestParameters: VehiclesListVehiclesMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.vehiclesListVehiclesMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehiclesReadVehicle without sending the request
     */
    async vehiclesReadVehicleRequestOpts(requestParameters: VehiclesReadVehicleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleId'] == null) {
            throw new runtime.RequiredError(
                'vehicleId',
                'Required parameter "vehicleId" was null or undefined when calling vehiclesReadVehicle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicles/{vehicle_id}`;
        urlPath = urlPath.replace('{vehicle_id}', encodeURIComponent(String(requestParameters['vehicleId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the vehicle specified by the given ID.
     * Get a single vehicle
     */
    async vehiclesReadVehicleRaw(requestParameters: VehiclesReadVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Vehicle>> {
        const requestOptions = await this.vehiclesReadVehicleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleFromJSON(jsonValue));
    }

    /**
     * Returns the vehicle specified by the given ID.
     * Get a single vehicle
     */
    async vehiclesReadVehicle(requestParameters: VehiclesReadVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Vehicle> {
        const response = await this.vehiclesReadVehicleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehiclesReadVehicleByVehicleDeviceSerialNumber without sending the request
     */
    async vehiclesReadVehicleByVehicleDeviceSerialNumberRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicles/by/vehicle_device`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns only the vehicle of vehicle device token
     * Get a single vehicle by vehicle device.
     */
    async vehiclesReadVehicleByVehicleDeviceSerialNumberRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Vehicle>> {
        const requestOptions = await this.vehiclesReadVehicleByVehicleDeviceSerialNumberRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleFromJSON(jsonValue));
    }

    /**
     * Returns only the vehicle of vehicle device token
     * Get a single vehicle by vehicle device.
     */
    async vehiclesReadVehicleByVehicleDeviceSerialNumber(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Vehicle> {
        const response = await this.vehiclesReadVehicleByVehicleDeviceSerialNumberRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehiclesReadVehicleCostInformation without sending the request
     */
    async vehiclesReadVehicleCostInformationRequestOpts(requestParameters: VehiclesReadVehicleCostInformationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['costsPeriodStart'] == null) {
            throw new runtime.RequiredError(
                'costsPeriodStart',
                'Required parameter "costsPeriodStart" was null or undefined when calling vehiclesReadVehicleCostInformation().'
            );
        }

        if (requestParameters['costsPeriodEnd'] == null) {
            throw new runtime.RequiredError(
                'costsPeriodEnd',
                'Required parameter "costsPeriodEnd" was null or undefined when calling vehiclesReadVehicleCostInformation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['costsPeriodStart'] != null) {
            queryParameters['costs_period_start'] = (requestParameters['costsPeriodStart'] as any).toISOString();
        }

        if (requestParameters['costsPeriodEnd'] != null) {
            queryParameters['costs_period_end'] = (requestParameters['costsPeriodEnd'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicles/cost_information`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns only the vehicle of vehicle device token
     * Get a single vehicle by vehicle device.
     */
    async vehiclesReadVehicleCostInformationRaw(requestParameters: VehiclesReadVehicleCostInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleFleetStatistics>> {
        const requestOptions = await this.vehiclesReadVehicleCostInformationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleFleetStatisticsFromJSON(jsonValue));
    }

    /**
     * Returns only the vehicle of vehicle device token
     * Get a single vehicle by vehicle device.
     */
    async vehiclesReadVehicleCostInformation(requestParameters: VehiclesReadVehicleCostInformationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleFleetStatistics> {
        const response = await this.vehiclesReadVehicleCostInformationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehiclesReadVehicleListStats without sending the request
     */
    async vehiclesReadVehicleListStatsRequestOpts(requestParameters: VehiclesReadVehicleListStatsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling vehiclesReadVehicleListStats().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['dateStart'] != null) {
            queryParameters['date_start'] = (requestParameters['dateStart'] as any).toISOString();
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['date_end'] = (requestParameters['dateEnd'] as any).toISOString();
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['includeInactive'] != null) {
            queryParameters['include_inactive'] = requestParameters['includeInactive'];
        }

        if (requestParameters['departmentIds'] != null) {
            queryParameters['department_ids'] = requestParameters['departmentIds'];
        }

        if (requestParameters['vehicleGroupIds'] != null) {
            queryParameters['vehicle_group_ids'] = requestParameters['vehicleGroupIds'];
        }

        if (requestParameters['procurementTypes'] != null) {
            queryParameters['procurement_types'] = requestParameters['procurementTypes'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicles/vehicle_list_stats`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch summed up stats of filtered vehicles.
     * Read summed up stats of all filtered vehicles.
     */
    async vehiclesReadVehicleListStatsRaw(requestParameters: VehiclesReadVehicleListStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VehicleListStats>> {
        const requestOptions = await this.vehiclesReadVehicleListStatsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleListStatsFromJSON(jsonValue));
    }

    /**
     * Fetch summed up stats of filtered vehicles.
     * Read summed up stats of all filtered vehicles.
     */
    async vehiclesReadVehicleListStats(requestParameters: VehiclesReadVehicleListStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VehicleListStats> {
        const response = await this.vehiclesReadVehicleListStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehiclesUpdateVehicle without sending the request
     */
    async vehiclesUpdateVehicleRequestOpts(requestParameters: VehiclesUpdateVehicleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleId'] == null) {
            throw new runtime.RequiredError(
                'vehicleId',
                'Required parameter "vehicleId" was null or undefined when calling vehiclesUpdateVehicle().'
            );
        }

        if (requestParameters['vehicleUpdate'] == null) {
            throw new runtime.RequiredError(
                'vehicleUpdate',
                'Required parameter "vehicleUpdate" was null or undefined when calling vehiclesUpdateVehicle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicles/{vehicle_id}`;
        urlPath = urlPath.replace('{vehicle_id}', encodeURIComponent(String(requestParameters['vehicleId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleUpdateToJSON(requestParameters['vehicleUpdate']),
        };
    }

    /**
     * Update the vehicle specified by the given ID.
     * Update vehicle
     */
    async vehiclesUpdateVehicleRaw(requestParameters: VehiclesUpdateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Vehicle>> {
        const requestOptions = await this.vehiclesUpdateVehicleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleFromJSON(jsonValue));
    }

    /**
     * Update the vehicle specified by the given ID.
     * Update vehicle
     */
    async vehiclesUpdateVehicle(requestParameters: VehiclesUpdateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Vehicle> {
        const response = await this.vehiclesUpdateVehicleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehiclesUpdateVehicleLastSynchronizedAt without sending the request
     */
    async vehiclesUpdateVehicleLastSynchronizedAtRequestOpts(requestParameters: VehiclesUpdateVehicleLastSynchronizedAtRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleLastSynchronizedAtUpdate'] == null) {
            throw new runtime.RequiredError(
                'vehicleLastSynchronizedAtUpdate',
                'Required parameter "vehicleLastSynchronizedAtUpdate" was null or undefined when calling vehiclesUpdateVehicleLastSynchronizedAt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicles/last_synchronized_at`;

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleLastSynchronizedAtUpdateToJSON(requestParameters['vehicleLastSynchronizedAtUpdate']),
        };
    }

    /**
     * Update the last synchronization date of the vehicle specified by the given ID.
     * Update vehicle last synchronization date
     */
    async vehiclesUpdateVehicleLastSynchronizedAtRaw(requestParameters: VehiclesUpdateVehicleLastSynchronizedAtRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Vehicle>> {
        const requestOptions = await this.vehiclesUpdateVehicleLastSynchronizedAtRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VehicleFromJSON(jsonValue));
    }

    /**
     * Update the last synchronization date of the vehicle specified by the given ID.
     * Update vehicle last synchronization date
     */
    async vehiclesUpdateVehicleLastSynchronizedAt(requestParameters: VehiclesUpdateVehicleLastSynchronizedAtRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Vehicle> {
        const response = await this.vehiclesUpdateVehicleLastSynchronizedAtRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for vehiclesValidateCreateVehicle without sending the request
     */
    async vehiclesValidateCreateVehicleRequestOpts(requestParameters: VehiclesValidateCreateVehicleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleCreate'] == null) {
            throw new runtime.RequiredError(
                'vehicleCreate',
                'Required parameter "vehicleCreate" was null or undefined when calling vehiclesValidateCreateVehicle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicles/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleCreateToJSON(requestParameters['vehicleCreate']),
        };
    }

    /**
     * Validate data for a new vehicle without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a vehicle
     */
    async vehiclesValidateCreateVehicleRaw(requestParameters: VehiclesValidateCreateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehiclesValidateCreateVehicleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new vehicle without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a vehicle
     */
    async vehiclesValidateCreateVehicle(requestParameters: VehiclesValidateCreateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehiclesValidateCreateVehicleRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for vehiclesValidateUpdateVehicle without sending the request
     */
    async vehiclesValidateUpdateVehicleRequestOpts(requestParameters: VehiclesValidateUpdateVehicleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['vehicleId'] == null) {
            throw new runtime.RequiredError(
                'vehicleId',
                'Required parameter "vehicleId" was null or undefined when calling vehiclesValidateUpdateVehicle().'
            );
        }

        if (requestParameters['vehicleUpdate'] == null) {
            throw new runtime.RequiredError(
                'vehicleUpdate',
                'Required parameter "vehicleUpdate" was null or undefined when calling vehiclesValidateUpdateVehicle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/vehicles/{vehicle_id}/validate`;
        urlPath = urlPath.replace('{vehicle_id}', encodeURIComponent(String(requestParameters['vehicleId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: VehicleUpdateToJSON(requestParameters['vehicleUpdate']),
        };
    }

    /**
     * Validate data for updating the given vehicle, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate vehicle update
     */
    async vehiclesValidateUpdateVehicleRaw(requestParameters: VehiclesValidateUpdateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.vehiclesValidateUpdateVehicleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given vehicle, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate vehicle update
     */
    async vehiclesValidateUpdateVehicle(requestParameters: VehiclesValidateUpdateVehicleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.vehiclesValidateUpdateVehicleRaw(requestParameters, initOverrides);
    }

}

/**
  * @export
  * @enum {string}
  */
export enum VehiclesExportVehicleListExportType {
    CSV = 'csv',
    XLSX = 'xlsx'
}
/**
  * @export
  * @enum {string}
  */
export enum VehiclesExportVehicleListListType {
    TRUCKS = 'trucks',
    PRODUCTIVITY = 'productivity'
}
